import { ReactComponent as Petrol } from "../../shared/assets/petrol.svg";
import { themeAtom } from "../../shared/atoms";
import LoadingWrapper from "../../shared/components/LoadingWrapper";
import { valOrNa } from "../../shared/services/utils";
import { getPortConsumption } from "../services/vessel-details.service";
import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { twMerge } from "tailwind-merge";

// TODO Add proper interface for fetched data
export function PortConsumption() {
  const theme = useAtomValue(themeAtom);

  const { imoNumber, vesselCode, vesselName } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [portConsumptionData, setPortConsumptionData] = useState<any[]>([]);

  useEffect(() => {
    const fetchPortConsumptionData = async () => {
      try {
        setLoading(true);
        const { working, idle } = await getPortConsumption(imoNumber, vesselCode);
        setPortConsumptionData([working, idle]);
        setLoading(false);
      } catch (error) {
        console.log("fetchData error", fetchPortConsumptionData);
        setLoading(false);
      }
    };

    fetchPortConsumptionData();
  }, [imoNumber, vesselCode, vesselName]);

  return (
    <LoadingWrapper isLoading={isLoading} loadingIndicatorClassName="text-green" loadingIndicatorSize="lg">
      <h1 className={twMerge("mb-1 pb-6 pt-4 text-lg font-bold", theme.home.tailwind.textDefault)}>
        In Port Consumption
      </h1>

      <div className={twMerge("... rounded border", theme.uwhcAssistant.border)}>
        <table className={twMerge("min-w-full divide-y", theme.uwhcAssistant.border, theme.vesselDetails.info)}>
          <tr className="text-xs font-semibold">
            <th className="flex justify-center py-3 text-left text-xs font-medium uppercase tracking-wider">
              <Petrol className="ml-1 h-5 w-4" />
            </th>
            <th className="w-1/5 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">&nbsp;</th>
            <th className="w-1/5 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">LSF</th>
            <th className="w-1/5 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">LSG</th>
            <th className="w-1/5 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">IFO</th>
            <th className="w-1/5 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">MGO</th>
          </tr>

          <tbody className={twMerge("divide-y", theme.uwhcAssistant.border, theme.home.tailwind.panelBackground)}>
            <tr className={twMerge("border-b", theme.uwhcAssistant.border)}>
              <td className="whitespace-nowrap text-xs">
                <div
                  className={twMerge(
                    "inline-flex h-[100px] w-12 items-center justify-start gap-2 border-b border-r px-1 py-2",
                    theme.vesselDetails.emerald,
                    theme.uwhcAssistant.border,
                  )}
                >
                  <div className="font-['Be Vietnam Pro'] -rotate-90 pb-2 text-xs font-semibold leading-none">
                    Working
                  </div>
                </div>
              </td>
              <td className="w-1/5 whitespace-nowrap px-6 py-4 text-xs">&nbsp;</td>
              <td className="w-1/5 whitespace-nowrap px-6 py-4 text-xs">
                <div className="flex items-center justify-start">
                  <Petrol className="mr-2 h-5 w-4" />
                  {valOrNa(portConsumptionData?.[0]?.LSF, "mt")}
                </div>
              </td>
              <td className="w-1/5 whitespace-nowrap px-6 py-4 text-xs">
                <div className="flex items-center justify-start">
                  <Petrol className="mr-2 h-5 w-4" />
                  {valOrNa(portConsumptionData?.[0]?.LSG, "mt")}
                </div>
              </td>
              <td className="w-1/5 whitespace-nowrap px-6 py-4 text-xs">
                <div className="flex items-center justify-start">
                  <Petrol className="mr-2 h-5 w-4" />
                  {valOrNa(portConsumptionData?.[0]?.IFO, "mt")}
                </div>
              </td>
              <td className="w-1/5 whitespace-nowrap px-6 py-4 text-xs">
                <div className="flex items-center justify-start">
                  <Petrol className="mr-2 h-5 w-4" />
                  {valOrNa(portConsumptionData?.[0]?.MGO, "mt")}
                </div>
              </td>
            </tr>

            <tr>
              <td className="whitespace-nowrap text-xs">
                <div
                  className={twMerge(
                    "inline-flex h-[100px] w-12 items-center justify-start gap-2 border-b border-r px-4 py-2",
                    theme.vesselDetails.emerald,
                    theme.uwhcAssistant.border,
                  )}
                >
                  <div className="font-['Be Vietnam Pro'] -rotate-90 pb-2 text-xs font-semibold leading-none">Idle</div>
                </div>
              </td>
              <td className="w-1/5 whitespace-nowrap px-6 py-4 text-xs">&nbsp;</td>
              <td className="w-1/5 whitespace-nowrap px-6 py-4 text-xs">
                <div className="flex items-center justify-start">
                  <Petrol className="mr-2 h-5 w-4" />
                  {valOrNa(portConsumptionData?.[1]?.LSF, "mt")}
                </div>
              </td>
              <td className="w-1/5 whitespace-nowrap px-6 py-4 text-xs">
                <div className="flex items-center justify-start">
                  <Petrol className="mr-2 h-5 w-4" />
                  {valOrNa(portConsumptionData?.[1]?.LSG, "mt")}
                </div>
              </td>
              <td className="w-1/5 whitespace-nowrap px-6 py-4 text-xs">
                <div className="flex items-center justify-start">
                  <Petrol className="mr-2 h-5 w-4" />
                  {valOrNa(portConsumptionData?.[1]?.IFO, "mt")}
                </div>
              </td>
              <td className="w-1/5 whitespace-nowrap px-6 py-4 text-xs">
                <div className="flex items-center justify-start">
                  <Petrol className="mr-2 h-5 w-4" />
                  {valOrNa(portConsumptionData?.[1]?.MGO, "mt")}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </LoadingWrapper>
  );
}
